import { render, staticRenderFns } from "./CategoryDetail.vue?vue&type=template&id=6a865d6e&scoped=true&"
import script from "./CategoryDetail.vue?vue&type=script&lang=ts&"
export * from "./CategoryDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryDetail.vue?vue&type=style&index=0&id=6a865d6e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a865d6e",
  null
  
)

export default component.exports